<template>
<div class="body">
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Dancing+Script&family=Source+Code+Pro&display=swap" rel="stylesheet">

<div class="container">
    <div class="type">
      <p class="name">My name is Josiah.</p>
      <p class="intro">I am a frontend web deleveloper</p>
      <p class="intro">Here is a list of my projects</p>
    </div>
    <ul class="items">
      <li class="item" :key="project.id" v-for="project in projects">
        <a :href="project.url" class="card__text">
          {{project.title}}
          <i v-if="project.external" i class="fa fa-external-link"></i>
        </a>
      </li>
    </ul>
  </div>
</div>

</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      projects: [
        {
          id: 1,
          title: 'Huddle With Curves *',
          url: 'huddle-w-curves',
        },
        {
          id: 2,
          title: 'Testimonial Grid Section *',
          url: 'testimonial-grid',
        },
        {
          id: 3,
          title: 'Social Proof Section',
          url: 'social-proof-section',
        },
        {
          id: 4,
          title: 'Fylo Landing Page',
          url: 'fylo-landing',
        },
        {
          id: 5,
          title: 'Column Preview Components',
          url: 'column-preview',
        },
        {
          id: 6,
          title: 'Four Card Feature Section',
          url: 'four-card-feature-section',
        },
        {
          id: 7,
          title: 'fylo two column landing page',
          url: 'fylo-2-column-landing-page',
        },
        {
          id: 8,
          title: 'Blogr',
          url: 'blogr',
        },
        {
          id: 9,
          title: 'Clipboard',
          url: 'clipboard',
        },
        {
          id: 10,
          title: 'Stock Prices',
          external: true,
          url: 'https://stock-prices.vercel.app/',
        },
        {
          id: 11,
          title: 'Pricing component *',
          external: true,
          url: 'https://pricing-component-with-toggle-seven-psi.vercel.app',
        },
        {
          id: 12,
          title: 'fylo data storage *',
          external: true,
          url: 'https://fylo-data-storage-component-two-xi.vercel.app',
        },
        {
          id: 13,
          title: 'social dashboard *',
          external: true,
          url: 'https://social-media-dashboard-bay-eight.vercel.app',
        },
        {
          id: 14,
          title: 'interactive pricing component *',
          external: true,
          url: 'https://interactive-pricing-component-three-rust.vercel.app',
        },
        {
          id: 15,
          title: 'huddle alternatative *',
          external: true,
          url: 'https://huddle-landing-page-with-alternating-feature-blocks-one.vercel.app',
        },
        {
          id: 16,
          title: 'huddle hero *',
          external: true,
          url: 'https://huddle-landing-page-with-single-introductory-section-xi.vercel.app',
        },
        {
          id: 17,
          title: 'ping page *',
          external: true,
          url: 'https://ping-coming-soon-page-gamma.vercel.app',
        },
        {
          id: 18,
          title: 'single price grid *',
          external: true,
          url: 'https://single-price-grid-component-beryl-five.vercel.app',
        },
        {
          id: 19,
          title: 'article preview',
          external: true,
          url: 'https://article-preview-seven-topaz.vercel.app',
        },
        {
          id: 20,
          title: 'intro sign form *',
          external: true,
          url: 'https://intro-component-with-sign-up-form-ivory.vercel.app',
        },
        {
          id: 21,
          title: 'base apparel *',
          external: true,
          url: 'https://base-apparel-coming-soon-page-neon.vercel.app',
        },
        {
          id: 22,
          title: 'bootcamp testimonials *',
          external: true,
          url: 'https://bootcamp-testimonials-lilac.vercel.app',
        },
        {
          id: 23,
          title: 'profile card *',
          external: true,
          url: 'https://profile-card-component-main-nu-two.vercel.app',
        },
        {
          id: 24,
          title: 'FAQ *',
          external: true,
          url: 'https://faq-mauve.vercel.app',
        },
        {
          id: 25,
          title: 'Crowdfunding',
          url: 'crowdfunding',
        },

      ],
    };
  },
};

</script>

<style lang="scss" scoped>

  .body {
    --bg-color: rgba(25, 25, 25, 1);
    --white: rgb(255, 255, 255);
    --animation-time: 1s;
    --ff-default: "Source Code Pro", monospace;
    --ff-alt: "Dancing Script", cursive;
    --ff-awesome: FontAwesome;

    --fs-small: 0.9375rem;
    --fs-base: 1.25rem;
    --fs-h3: 2rem;
    --fs-h2: 3rem;

    --sm-spacer: 0.5rem;

    background-color: var(--bg-color);
    font-size: var(--fs-base);
    color: var(--white);

    min-height: 100vh;
  }

  .container {
    width: 80%;
    margin: 0 auto;
    padding-top: 3rem;

    display: grid;
    place-items: center;
  }

  .type {
    .name {
      position: relative;
      font-size: var(--fs-h1);
      font-family: var(--ff-default);

      @media (min-width: 60em) {
        font-size: var(--fs-h2);
      }

      &::before,
      &::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }

      &::before {
        background: var(--bg-color);
        animation: type var(--animation-time) 0.5s steps(18) forwards;
      }

      &::after {
        content: "\270f";
        font-family: var(--ff-awesome);
        font-size: var(--fs-small);
        animation: type var(--animation-time) 0.5s steps(18) forwards,
          blink 800ms steps(25) infinite;
        @media (min-width: 60em) {
          font-size: var(--fs-base);
        }
      }

      @keyframes type {
        to {
          left: 100%;
        }
      }

      @keyframes blink {
        25% {
          top: 70%;
        }
        50% {
          top: 0%;
        }
        75% {
          top: 70%;
        }
        100% {
          top: 0%;
        }
      }
    }
    .intro {
      opacity: 0;
      font-size: var(--fs-base);
      animation: slide 1s var(--animation-time) ease-in-out forwards;
      transform: translatey(15rem);
      font-family: var(--ff-alt);
      text-align: center;

      @keyframes slide {
        100% {
          opacity: 1;
          transform: translatey(0);
        }
      }
    }
  }

  .items {
    font-size: var(--fs-base);
    margin-top: 3rem;
    list-style: none;
    counter-reset: count;
    text-transform: capitalize;

    .item + .item {
      margin-top: var(--sm-spacer);
    }

    @media (min-width: 60em) {
      font-size: var(--fs-base);
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 0.5rem 3rem;

      .item + .item {
        margin-top: 0;
      }

    }

    .item::before {
        font-family: "Dancing Script", cursive;
        counter-increment: count;
        content: counter(count) ". ";
    }

    a {
      text-decoration: none;
      color: inherit;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 100%;
        right: 100%;
        background-color: currentColor;
        height: 0.1rem;

        transition: all 350ms ease-out;
      }

     &:hover::after {
      left: 0;
      right: 0;
     }
    }
  }

</style>
